import React, { useEffect, useState } from 'react';
import { ChevronUp, ChevronDown, Eye, EyeOff, Download, X } from 'lucide-react';
import { Button } from '../../Common/Button';
import FastagPurchase from '../../Commponent/FastagPurchase';
import CommonTable from '../../Common/CommonTable';
import AddAgent from '../../Commponent/AddAgent';
import AddBulkAgents from '../../Commponent/AddBulkAgents';
import { getVehicleClassData } from '../../Utils/helper';
import { useDispatch, useSelector } from 'react-redux';
import { ACTIONS } from '../../redux/actions';
import { ErrorToast, SuccessToast } from '../../Utils/toast';
import moment from 'moment';
import CommonModal from '../../Commponent/CommonModal';
import { API } from '../../Common/Api';
import { getRole } from '../../Utils/auth';

const StatusBadge = ({ status }) => {
  const base = "px-2 py-[2px] rounded-full text-xs font-medium flex items-center gap-1 justify-self-start";

  // Map requestStatus to display values
  if (status === "Approved" || status === "Assigned")
    return <span className={`${base} bg-green-100 text-green-900`}><span className="h-2 w-2 bg-green-500 rounded-full" />Assigned</span>;
  if (status === "Rejected" || status === "Unassigned")
    return <span className={`${base} bg-red-100 text-red-900`}><span className="h-2 w-2 bg-red-500 rounded-full" />Rejected</span>;
  if (status === "Pending")
    return <span className={`${base} bg-yellow-100 text-yellow-900`}><span className="h-2 w-2 bg-yellow-500 rounded-full" />Unassigned</span>;
  return null;
};

//Agnet MyFastagRequest; 
const MyFastagRequest = () => {
  const dispatch = useDispatch();
  const GetAllFastagAgentRequest = useSelector((state) => state.GetAllFastagAgentRequest.GetAllFastagAgentRequestData);
  const CreateAgentBulk = useSelector((state) => state.CreateAgentBulk.CreateAgentBulkData);
  const GetDistributorSummary = useSelector((state) => state.GetDistributorSummary.GetDistributorSummaryData);
  const refreshCount = useSelector((state) => state.Refresh?.refreshCount);
  const [show, setShow] = useState(false);
  const [addAgentsOpen, setAddAgentsOpen] = useState(false);
  const [addBulkAgentsOpen, setAddBulkAgentsOpen] = useState(false);
  const [visibleRows, setVisibleRows] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedClass, setSelectedClass] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [checkGetDistributorRequest, setCheckGetDistributorRequest] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [approvalNote, setApprovalNote] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: "", direction: null });
  const [file, setFile] = useState("");
  const [userData, setUserData] = useState(null);
  const [checkCreateAgentBulk, setCheckCreateAgentBulk] = useState(false);
  const [checkGetDistributorSummary, setCheckGetDistributorSummary] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    getData()
    getDataInit()
    getDistributorSummaryData()
  }, []);

  // Refresh data when pagination or global refresh changes
  useEffect(() => {
    getData()
  }, [currentPage, itemsPerPage, refreshCount]);


  const getDataInit = async () => {
    const data = localStorage.getItem('UserDetail');


    setUserData(JSON.parse(data));
  }


  const getData = () => {
    let params = {
      page: currentPage,
      limit: itemsPerPage,
    }
    setCheckGetDistributorRequest(true)
    dispatch(ACTIONS.GetAllFastagAgentRequestAction(params));
  }

  const getDistributorSummaryData = () => {
    setCheckGetDistributorSummary(true);
    dispatch(ACTIONS.GetDistributorSummaryAction());
  }

  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return {
          key,
          direction:
            prev.direction === "asc"
              ? "desc"
              : prev.direction === "desc"
                ? null
                : "asc",
        };
      }
      return { key, direction: "asc" };
    });
  };
  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      if (sortConfig.direction === "asc")
        return (
          <ChevronUp className="w-[18px] h-[18px] inline-block ml-1 text-[#9C9C9C]" />
        );
      if (sortConfig.direction === "desc")
        return (
          <ChevronDown className="w-[18px] h-[18px] inline-block ml-1 text-[#9C9C9C]" />
        );
    }
    return (
      <ChevronDown className="w-[18px] h-[18px] inline-block ml-1 text-[#E0E0E0]" />
    );
  };



  useEffect(() => {
    if (checkGetDistributorRequest) {
      if (GetAllFastagAgentRequest?.status == 200 && GetAllFastagAgentRequest?.success) {
        setTableData(GetAllFastagAgentRequest?.data);
      } else {
        ErrorToast(GetAllFastagAgentRequest?.message);
      }
      setCheckGetDistributorRequest(false)
    }
  }, [GetAllFastagAgentRequest])

  // Handle CreateAgentBulk response
  useEffect(() => {
    if (CreateAgentBulk && checkCreateAgentBulk) {
      // Check if the API call was successful (status 200)
      if (CreateAgentBulk?.status === 200) {
        const { message, inserted, failed, details } = CreateAgentBulk;

        // Create detailed success message based on status only
        let detailedMessage = `${message || 'Bulk agent upload completed'}. Successfully added: ${inserted || 0} agents`;

        // Add failure information if any
        if (failed && failed > 0) {
          detailedMessage += `, Failed: ${failed}`;

          // Show detailed failure information only if there are actual failures
          if (details?.failed && Array.isArray(details.failed) && details.failed.length > 0) {
            const failureReasons = details.failed.map(failure => {
              // Handle your API structure: failure.data contains the original row data
              const username = failure.data?.username || 'Unknown';
              const reason = failure.reason || 'Unknown error';
              const rowNumber = failure.row || 'Unknown row';
              return `Row ${rowNumber} (${username}): ${reason}`;
            }).join('; ');

            // Show warning toast for failures
            setTimeout(() => {
              ErrorToast(`Failed entries: ${failureReasons}`);
            }, 1000);
          }
        }

        // Show success toast for status 200
        SuccessToast(detailedMessage);
        getData(); // Refresh data
        setAddBulkAgentsOpen(false); // Close modal
        setFile(''); // Reset file
      } else {
        // Handle error cases (400, 500, etc.)
        const errorMessage = CreateAgentBulk?.message || CreateAgentBulk?.error || 'Failed to create bulk agents';
        ErrorToast(errorMessage);
        // Keep modal open for user to fix issues
      }

      setCheckCreateAgentBulk(false);
    }
  }, [CreateAgentBulk, checkCreateAgentBulk])

  // Handle GetDistributorSummary response
  useEffect(() => {
    if (checkGetDistributorSummary) {
      if (GetDistributorSummary?.status === 200 && GetDistributorSummary?.success) {
        console.log(' Dashboard - Distributor Summary API Response:', GetDistributorSummary?.data);
      } else {
        console.error(' Dashboard - Failed to fetch distributor summary:', GetDistributorSummary?.message);
      }
      setCheckGetDistributorSummary(false);
    }
  }, [GetDistributorSummary, checkGetDistributorSummary])

  const [assigningAgent, setAssigningAgent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleVisibility = (index, row) => {
    const isVisible = visibleRows[index];
    const newVisibility = { ...visibleRows, [index]: !isVisible };
    setVisibleRows(newVisibility);

    if (window.innerWidth >= 0) {
      setModalOpen(!isVisible);
    }

    if (!isVisible) {
      setSelectedClass(row);
      setSelectedIndex(index);
    }
  };

  const vehicleData = getVehicleClassData(selectedClass.vehicleClass);

  const tableColumns = [
    {
      label: "Requested By",
      key: "name",
      render: (row) => (
        <div>
          <div className="font-medium text-[#1F1715]">{row.user?.username}</div>
          <div className="text-xs text-[#000000]">{row.user?.email}</div>
        </div>
      ),
    },
    // { label: "Mobile Number", render: (row) => row.user?.mobileNo },
    {
      label: (
        <div
          className="flex items-center gap-1 cursor-pointer"
          onClick={() => handleSort("vehicleClass")}
        >
          Vehicle Class {getSortIcon("vehicleClass")}
        </div>
      ),
      key: "vehicleClass",
      render: (item, idx) => {
        const vehicleClassData = getVehicleClassData(item.vehicleClass);
        return (
          <div className="flex gap-2 items-center">
            <img
              src={vehicleClassData?.tagimage}
              alt="Tag"
              className="w-[34px]"
            />
            <p>{vehicleClassData.value}</p>
            <div
              className="pl-2 flex items-center cursor-pointer"
              onClick={() => toggleVisibility(idx, item)}
            >
              {visibleRows[idx] ? <Eye className="h-5 w-5" /> : <EyeOff className="h-5 w-5" />}
            </div>
          </div>
        );
      },
    },
    { label: "Requested Date", render: (row) => moment(row.createdAt).format("DD MMMM, YYYY hh:mm A"), },
    // { label: "Recieved Date", render: (row) => moment(row.updatedAt).format("DD MMMM, YYYY hh:mm A"), },
    { label: "Approx Quantity", key: "quantity" },
    { label: "Supplier Contact", render: (row) => row.distributorId?.mobileNo },
    {
      label: "Supplier Name",
      render: (row) => row.distributorId?.username
    },
    {
      label: "Status",
      tdClassName: 'flex justify-end',
      render: (row) => <StatusBadge status={row.requestStatus} />,
    }

  ];



  const handleApprove = async () => {
    const data = {
      FasTagIds: [assigningAgent._id],
      remark: approvalNote
    }

    const response = await API.ApproveFastag(JSON.stringify(data));

    if (response.status === 200 && response.success) {
      SuccessToast(response.message);
      dispatch({ type: "REFRESH_DATA" });
      // getData() // redundant now
      setIsModalOpen(false);
    } else {
      ErrorToast(response.message);
    }

  }

  const total = tableData.length;
  const totalPages = Math.ceil(total / itemsPerPage);


  // Bulk agent handlers
  const handleSubmit = () => {
    if (file) {
      const formData = new FormData();
      formData.append('file', file);

      // Dispatch Redux action for bulk agent creation
      setCheckCreateAgentBulk(true);
      dispatch(ACTIONS.CreateAgentBulkAction(formData));
    } else {
      ErrorToast('Please select a file to upload.');
    }
  }

  const handleUpload = (fileRaw) => {
    setFile(fileRaw);
  }


  return (
    <>
      <div className="">
        <div className="mx-auto">
        </div>
        {modalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
            <div className="relative bg-white rounded-[20px] shadow-lg w-full max-w-xl p-6">
              <div className="absolute top-4 right-4 gap-3 flex-row flex">
                <button
                  onClick={() => {
                    const link = document.createElement('a');
                    link.href = vehicleData.pdf;
                    link.download = 'vehicle_class.pdf';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }}
                  className="text-gray-600 hover:text-red-500"
                >
                  <Download size={20} />
                </button>
                <button
                  onClick={() => {
                    setModalOpen(false);
                    if (selectedIndex !== null) {
                      toggleVisibility(selectedIndex, selectedClass);
                    }
                  }}
                  className="text-gray-600 hover:text-red-500"
                >
                  <X size={20} />
                </button>
              </div>
              <h2 className="text-xl font-semibold mb-[4px] text-center">
                {vehicleData?.value}
              </h2>
              <p className="mb-[30px] text-sm text-center">
                {vehicleData?.description}
              </p>
              <div className="relative w-full flex justify-center items-center py-8 px-4">
                <div className="relative bg-white p-8 rounded-2xl shadow-2xl border border-gray-200 max-w-2xl w-full">
                  {/* Decorative corner accents */}
                  <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-red-500 rounded-tl-2xl opacity-20"></div>
                  <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-red-500 rounded-br-2xl opacity-20"></div>

                  {/* Image container with classic frame */}
                  <div className="relative bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-xl border-2 border-gray-300 shadow-inner">
                    <img
                      src={vehicleData?.cardWebp}
                      alt={vehicleData?.name}
                      className="w-full h-auto object-contain rounded-lg transition-transform duration-500 hover:scale-[1.12]"
                    />
                  </div>

                  {/* Elegant bottom accent */}
                  <div className="mt-6 flex justify-center">
                    <div className="h-1 w-24 bg-gradient-to-r from-transparent via-red-500 to-transparent rounded-full"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <CommonModal
          isOpen={isModalOpen}
          closeOnOutsideClick={false}
          onClose={() => setIsModalOpen(false)}
          title={`FASTag Request: ${assigningAgent?.user?.username}`}
          size="max-w-xl"
          footer={
            <div className="flex justify-end gap-4">
              <Button
                label="Cancel"
                onClick={() => setIsModalOpen(false)}
                className="bg-gray-200 text-gray-800 hover:bg-gray-300 px-4 py-2 rounded-md"
              />
              <Button
                label="Approve"
                onClick={handleApprove}
                className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-md"
              />
            </div>
          }
        >
          <div className="grid grid-cols-2 gap-3 mb-3">
            <label className="block text-sm font-medium text-gray-700 ">Assigning Agent : {assigningAgent?.user?.username}</label>
            <label className="block text-sm font-medium text-gray-700 ">Mobile : {assigningAgent?.user?.mobileNo}</label>
            <label className="block text-sm font-medium text-gray-700 ">Vehicle Class : {assigningAgent?.vehicleClass}</label>
            <label className="block text-sm font-medium text-gray-700 ">UTR Number : {assigningAgent?.utrnumber}</label>
            <label className="block text-sm font-medium text-gray-700 ">Quantity : {assigningAgent?.quantity}</label>
            <label className="block text-sm font-medium text-gray-700 ">Total Amount : {assigningAgent?.price}</label>
            <label className="block text-sm font-medium text-gray-700 ">Requested Date : {moment(assigningAgent?.createdAt).format('DD MMMM, YYYY, hh:mm A')}</label>

          </div>

          <label className="block text-sm font-medium text-gray-700 mb-3">Approval Note</label>
          <input
            type="text"
            placeholder="Enter remarks (optional)"
            value={approvalNote}
            onChange={(e) => setApprovalNote(e.target.value)}
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
          />
        </CommonModal>

      </div >

      {/* Table Header */}
      {/* < div className="" >
        <div className="flex justify-between items-center px-[20px]">
          <h2 className="text-[16px] font-semibold py-[20px]">My Fastag Request</h2> */}
      {/* <div
            onClick={() => navigate('/agents')}
            className="rounded-full p-[3px] w-[36px] h-[36px] flex justify-center items-center my-2 cursor-pointer hover:bg-gray-200 transition"
            style={{ backgroundColor: "#F5F5F5" }}
          >
            <MoveUpRight className="text-[#EE3B31]" />
          </div> */}
      {/* </div>
      </div > */}

      {/* Table */}
      < CommonTable columns={tableColumns}
        tablename="My Fastag Request"
        data={tableData}
        emptyMessage="No Inventory Found"
        isPagination={true}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        setCurrentPage={setCurrentPage}
        setItemsPerPage={setItemsPerPage}
        total={total}
        totalPages={totalPages}
        hideDateAndDownload={getRole() === 'agent'} />

      {show && <FastagPurchase onClose={() => { setShow(false); getData(); getDataInit(); getDistributorSummaryData(); }} />}
      {addAgentsOpen && <AddAgent onClose={() => { setAddAgentsOpen(false); getData(); getDataInit(); getDistributorSummaryData(); }} modalOpen={addAgentsOpen} setModalOpen={setAddAgentsOpen} />}
      {addBulkAgentsOpen && (
        <AddBulkAgents
          onClose={() => { setAddBulkAgentsOpen(false); getData(); getDataInit(); getDistributorSummaryData(); }}
          sidebarTitle="Add Bulk Agent +"
          sampleFileName="upload_agent_sample"
          csvFileName="upload agent sample.csv"
          xlsxFileName="upload agent sample.xlsx"
          sampleFileUrls={{
            excel: "/upload agent sample.xlsx",
            csv: "/upload agent sample.csv"
          }}
          onUpload={handleUpload}
          onSubmit={handleSubmit}
        />
      )}
    </>
  );
};

export default MyFastagRequest;
